import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../../UserContext";
import PandaProfile from "../../../../assets/PandaProfile.png";
import mountainAndPath from "../../../../assets/mountainAndPath.png";
import MountainMan from "../../../../assets/MountainMan.png";
import learningPathFlag from "../../../../assets/learningPathFlag.png";
import { apiFetch } from "../../../../services/apiFetch";

import { FaLocationDot, FaChevronDown } from "react-icons/fa6";

const apiBaseURL = process.env.REACT_APP_BACKEND_API_URL;

const YourCareerProgressionJourney = ({ onFocusLearningPath }) => {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const USER_ID = user?.user_id;

  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [courseProgress, setCourseProgress] = useState(null);
  // eslint-disable-next-line
  const [completedSubs, setCompletedSubs] = useState({});
  // eslint-disable-next-line
  const [activeModuleIndex, setActiveModuleIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [coursesLoaded, setCoursesLoaded] = useState(false);

  /* ================= FETCH COURSES ================= */
  useEffect(() => {
    if (!USER_ID) return;

    apiFetch(`${apiBaseURL}/courses`)
      .then((r) => r.json())
      .then((data) => setCourses(Array.isArray(data) ? data : []))
      .catch(() => setCourses([]))
      .finally(() => setCoursesLoaded(true));
  }, [USER_ID]);

  /* ================= DEFAULT COURSE ================= */
  useEffect(() => {
    if (!coursesLoaded || selectedCourse) return;

    if (courses.length > 0) {
      setSelectedCourse(courses[0]);
      return;
    }

    // No courses available - stop loading state
    setCourseProgress({ modules: [] });
    setLoading(false);
  }, [coursesLoaded, courses, selectedCourse]);

  /* ================= USER STATE ================= */
  useEffect(() => {
    if (!USER_ID || !courses.length || selectedCourse) return;

    apiFetch(`${apiBaseURL}/users/${USER_ID}/state`)
      .then((r) => (r.ok ? r.json() : null))
      .then((state) => {
        if (!state?.current_subsection) return;

        const found = courses.find((c) =>
          c.modules.some((m) =>
            m.subsections.some((s) => s.id === state.current_subsection)
          )
        );

        if (found) setSelectedCourse(found);
      });
  }, [USER_ID, courses, selectedCourse]);

  /* ================= COURSE PROGRESS ================= */
  useEffect(() => {
    if (!USER_ID || !selectedCourse) return;

    setLoading(true);

    apiFetch(
      `${apiBaseURL}/users/${USER_ID}/courses/${selectedCourse.id}/progress`
    )
      .then((r) => r.json())
      .then((data) => {
        setCourseProgress(data);

        const completedMap = {};
        data.modules.forEach((m) =>
          m.subsections.forEach((s) => {
            if (s.completed) completedMap[s.id] = true;
          })
        );

        setCompletedSubs(completedMap);

        const idx = data.modules.findIndex(
          (m) => m.id === data.active_module_id
        );

        setActiveModuleIndex(idx >= 0 ? idx : 0);
      })
      .finally(() => setLoading(false));
  }, [USER_ID, selectedCourse]);

  if (loading || !courseProgress) {
    return <div className="p-10 text-gray-500">Loading…</div>;
  }

  const modules = courseProgress.modules || [];
  // const activeModule = modules[activeModuleIndex];

  const module1Completed = (() => {
    const module1 = modules.find((m) => m.order === 1);
    if (!module1 || !module1.subsections?.length) return false;
    return module1.subsections.every(
      (sub) => sub.completed || sub.status === "completed"
    );
  })();

  const isActionPlanLocked = !module1Completed;

  // const leftModules = modules.slice(0, activeModuleIndex);
  // const rightModules = modules.slice(activeModuleIndex + 1);

  // const renderSideModule = (m, index, realIndex) => {
  //   const isCompleted = m.subsections?.every(
  //     (s) => completedSubs[s.id]
  //   );

  //   return (
  //     <div
  //       key={m.id}
  //       onClick={() => setActiveModuleIndex(realIndex)}
  //       className={`w-[72px] md:w-[80px] h-[420px] rounded-[11px] 
  //         flex items-center justify-center cursor-pointer
  //         transition-all duration-300
  //         ${isCompleted ? "bg-[#6FB1AF]" : "bg-[#D1D5DB]"}
  //         hover:scale-[1.03]
  //       `}
  //     >
  //       <span
  //         className="text-white text-sm md:text-lg font-medium text-center px-1"
  //         style={{
  //           writingMode: "vertical-rl",
  //           transform: "rotate(180deg)",
  //         }}
  //       >
  //         Module {m.order}
  //       </span>
  //     </div>
  //   );
  // };

  return (
    <section className="w-full bg-white overflow-y-scroll scrollbar-hide h-full pb-8">
      {/* ================= HEADER ================= */}
      <div className="px-10 pt-8 md:pt-1 flex justify-between items-start">
        <div>
          <h1 className="text-[34px] font-medium">
            Welcome to Your Career Progression Journey
          </h1>
          <p className="mt-3 max-w-xl text-[17px]">
            This is your space to reflect, track, and visualise grow.
            Everything that matters to your career journey, in one place.
          </p>
        </div>

        <img src={PandaProfile} alt="" className="w-20 h-20 rounded-full" />
      </div>

      {/* ================= MOUNTAIN ================= */}
      <div className="relative mt-16">
        <img src={mountainAndPath} alt="" className="w-full" />

        <img src={MountainMan} alt="" className="absolute bottom-[7%] left-[5%] w-16 h-[120px]" />
        <img src={learningPathFlag} alt="" className="absolute bottom-[53%] left-[55.6%] w-10" />
        <img src={learningPathFlag} alt="" className="absolute -top-[14.5%] right-[14.1%] w-10" />

        <div className="absolute left-[4.5%] bottom-[40%] text-xs">
          YOU ARE HERE
          <FaLocationDot className="text-[#54B0AF] text-2xl mt-1 ml-8" />
        </div>

        <div className="absolute top-0 right-[9%] text-right text-xs">
          <div>YOUR FUTURE</div>
          <div>CAREER ROLE</div>
        </div>

        {/* Bottom Labels with Navigation */}
        <div className="absolute left-0 right-0 flex justify-between px-2 text-sm md:text-[10.71px] font-normal font-gotham text-[#363636]">
          <div className="flex justify-between w-full gap-2">

            {/* YOUR LEARNING PATH - focus learning path below */}
            <div
              onClick={() => {
                if (onFocusLearningPath) {
                  onFocusLearningPath();
                  return;
                }
                navigate("/learner/learning");
              }}
              className="
                w-[58%]
                border border-b-black border-l-black border-r-black
                px-2 py-1
                text-sm md:text-[10.71px]
                font-normal font-gotham
                bg-transparent
                transition-all duration-300 ease-in-out
                hover:bg-[#54B0AF]
                underline
                text-blue-600
                hover:text-white
                hover:shadow-md
                cursor-pointer
                flex flex-col items-center justify-center
              "
            >
              <span>YOUR LEARNING PATH</span>
              <FaChevronDown className="text-[10px] -mt-0.5" aria-hidden />
            </div>

            {/* YOUR ACTION PLAN - Navigate to /learner/action-plan */}
            <div
              onClick={() => {
                if (!isActionPlanLocked) {
                  navigate("/learner/action-plan");
                }
              }}
              className={`
                w-[42%]
                border border-b-black border-l-black border-r-black
                px-2 py-1
                text-sm md:text-[10.71px]
                font-normal font-gotham
                bg-transparent
                text-blue-600
                text-center
                transition-all duration-300 ease-in-out
                underline
                ${isActionPlanLocked ? "opacity-50 cursor-not-allowed" : "hover:bg-[#54B0AF] hover:text-white hover:shadow-md cursor-pointer"}
              `}
            >
              YOUR ACTION PLAN
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default YourCareerProgressionJourney;
